import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import Loading from '~components/common/Loading';
import queryParam from '~utils/queryparams';
import updateDataLayer from '~utils/events';
import * as Sentry from '@sentry/gatsby';
import { CustomizableButton } from '~components/common/Button';
import ContentDiv from '../common/ContentDiv';

async function doRequest(setApiSuccess, uuid, token) {
  setApiSuccess(null);

  try {
    await axios.put(
      `${process.env.GATSBY_API_URL}registration/confirm-print-and-forward/${uuid}/?token=${token}`,
      {}
    );
    setApiSuccess(true);
    updateDataLayer({
      event: 'action-finish',
      method: 'pdf-forward-confirmed',
      tool: 'register',
      url: undefined,
    });
  } catch (error) {
    /* eslint-disable-next-line no-console */
    console.warn(error?.response?.data ?? error);
    Sentry.captureException(error);

    setApiSuccess(false);
  }
}

function Confirm({ successPage }) {
  const [apiSuccess, setApiSuccess] = useState(null);
  const requestSent = useRef();

  const uuid = queryParam('id');
  const token = queryParam('token');

  const successUrl =
    successPage === 'donate'
      ? `/tools/register/donate/`
      : `/tools/register/share/`;

  useEffect(() => {
    if (uuid && token && !requestSent.current) {
      requestSent.current = true;
      doRequest(setApiSuccess, uuid, token);
    }
  }, [uuid, token]);

  if (!(uuid && token)) {
    return <p>You have clicked an invalid link.</p>;
  }

  if (apiSuccess === true) {
    return (
      <ContentDiv>
        <h1>Your request has been confirmed</h1>
        <p>Your ballot request form will arrive in the mail in 6-10 days.</p>
        <p>
          Please double-check the information on the form to ensure that all
          required fields have been completed. Then sign and date the form where
          indicated.
        </p>
        <p>
          Place your form into the postage-paid envelope, and return it to the
          address on the coversheet.
        </p>
        <CustomizableButton
          to={successUrl}
          successPage={successPage}
          state={{ variant: 'form-mail' }}
          data-element-id='btn_register_confirm_continue'
          elementType='Link'
        >
          Continue
        </CustomizableButton>
      </ContentDiv>
    );
  }

  if (apiSuccess === false) {
    return (
      <>
        <p>The request failed.</p>
        <CustomizableButton
          type='button'
          onClick={() => doRequest(setApiSuccess, uuid, token)}
          data-element-id='btn_register_confirm_try-again'
          elementType='Link'
        >
          Try again
        </CustomizableButton>
      </>
    );
  }

  return (
    <>
      <h2 className='no-margin-top'>Loading...</h2>
      <Loading />
    </>
  );
}

Confirm.propTypes = {
  successPage: PropTypes.oneOf(['donate', 'share']),
};

Confirm.defaultProps = {
  successPage: 'donate',
};

export default Confirm;
